import { inject, Injectable } from '@angular/core';
import { DestinationDTOWithIcon } from '@pc/destinations-details';
import { map, Observable, of } from 'rxjs';
import { IDestinationData } from '../models/destination-response.interface';
import { countriesStub } from '../stubs/countries-data-stub';
import { RestApiService } from '@pc/services';
import { EnvironmentService } from '../../environment/environment.service';

@Injectable({
  providedIn: 'root'
})
export class DestinationService {
  private environmentService = inject(EnvironmentService);
  private devMode = this.environmentService.environment.flags.pureDevMode;
  private restApiService = inject(RestApiService);

  public getDestinations(): Observable<DestinationDTOWithIcon[]> {
    return this.getAllDestinations().pipe(
      map((destinations) => {
        return destinations.map((destination) => this.mapDestination(destination));
      })
    );
  }

  private getAllDestinations(): Observable<IDestinationData[]> {
    if (this.devMode) {
      return of(JSON.parse(countriesStub) as IDestinationData[]);
    }

    return this.restApiService.get('destination/getAllDestinations').pipe(
      map((response) => {
        return response.data;
      })
    );
  }

  private mapDestination(destinationData: IDestinationData): DestinationDTOWithIcon {
    return {
      id: destinationData.CountryId,
      areaID: destinationData.AreaId,
      title: destinationData.Country,
      titleLocal: destinationData.CountryLocal,
      popularityOrder: destinationData.PopularityOrder,
      aliases: destinationData.Aliases,
      countryISOCode: destinationData.CountryISOCode,
      phoneCode: destinationData.CountryPhoneCode,
      IsDomestic: destinationData.IsDomestic,
      icon: 'assets/flags/' + destinationData.CountryISOCode.toLowerCase() + '.svg' || 'assets/flags/default-flag.svg'
    } as DestinationDTOWithIcon;
  }
}
